export default __webpack_public_path__ + "images/4873310b082c0ecb464bc1a0ec3b8618-first_aid.jpg";